export default __webpack_public_path__ + "static/media/Itinerary_Card.d1b47414.svg";